<template>
  
  <div>
    <div class="ui header no-margin no-padding" style="font-size: 15px;">
      {{ label }}            
      <button class="ui mini icon right floated button" style="font-size: 16px !important; padding: 1px !important;" 
        @click="$emit('onClose')">
        <i class="times icon" style="font-size: 12px !important;"></i>
      </button>
    </div>    
    <div class="ui divider no-margin no-padding" style="margin-top: 3px !important;"></div>
  </div>

</template>

<script>

  export default {    
    props: ["label"],
  }

</script>

